// extracted by mini-css-extract-plugin
export default {"modalOverlay":"qB-z","modalContent":"rB-z","header":"sB-z","close":"tB-z"};